/* =================== MODAL =================== */

// Abre o modal
function openModal(modal) {
  $("body").addClass("modal-open");
  $("#" + modal).addClass("open");
  $("#" + modal).trigger("modal-open");
}

// Fecha o modal
function closeModal(modal) {
  $("body").removeClass("modal-open");
  $("#" + modal).removeClass("open");
  $("#" + modal).trigger("modal-close");
}

// Abre o modal de alerta
function showAlert(titulo, mensagem, tipo) {
  $("#modal-alert").removeClass("success warning error");
  $("#modal-alert").addClass(tipo);
  $("#alert-titulo").text(titulo);
  $("#alert-texto").html(mensagem);
  openModal("modal-alert");
}

$(function () {
  // Abre o modal ao clicar no botão
  $(".modal-open").on("click", function (e) {
    e.preventDefault();
    openModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar no botão
  $(".modal-close").on("click", function (e) {
    e.preventDefault();
    closeModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar em qualquer outro lugar da tela
  $(".modal").on("click", function (e) {
    if (e.target == this && !$(this).hasClass("modal-force")) {
      closeModal($(this).attr("id"));
    }
  });

  // Fecha o modal ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      $(".modal.open")
        .not(".modal-force")
        .each(function () {
          closeModal($(this).attr("id"));
        });
    }
  });

// Abre o modal de vídeo (Arquivo Local)
$(".modal-video-open").on("click", function (e) {
    e.preventDefault();
    const $el = $(this);
    // Captura a URL do arquivo de vídeo local
    openModalVideo($el.data("video-src"), $el.data("video-tit"));
});

function openModalVideo(videoSrc, videoTit = "") {
    const $modalVideo = $("#modal-video");
    
    if ($modalVideo.length) {
        // Criamos a tag video com controles, autoplay e playsinline (bom para mobile)
        const videoElement = `
            <video src="${videoSrc}" autoplay controls playsinline style="width: 100%; height: 100%; display: block;">
                Seu navegador não suporta a reprodução de vídeos.
            </video>`;
        
        // Insere o elemento de vídeo dentro do container do modal
        $modalVideo.find(".bloco-video-wrapper-modal").html(videoElement);
        
        if (videoTit != "") {
            $modalVideo.find(".bloco-video-titulo").html(videoTit);
        }
        
        openModal("modal-video");
    }
}

  // Fecha o modal de vídeo (Youtube)
  $("#modal-video").on("modal-close", function () {
    $("#modal-video").find(".bloco-video-wrapper").html("");
    $("#modal-video").find(".bloco-video-titulo").html("");
  });
});

$(document).on('click', '.bloco-video-empreendimento', function(){

    var videoUrl = $(this).data('video');
    var titulo   = $(this).data('video-tit');

    $('#videoPlayer source').attr('src', videoUrl);
    $('#videoPlayer')[0].load();

    $('.video-modal-title').text(titulo);
    $('#videoModal').addClass('active');

    $('#videoPlayer')[0].play();
});

$(document).on('click', '.video-modal-close', function(){
    fecharVideoModal();
});

$(document).on('click', '#videoModal', function(e){
    if(e.target === this){
        fecharVideoModal();
    }
});

function fecharVideoModal(){

    var video = $('#videoPlayer')[0];

    video.pause();
    video.currentTime = 0;

    $('#videoPlayer source').attr('src', '');
    video.load();

    $('#videoModal').removeClass('active');
}
